import { styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../../../constants/layout.mjs';
import { theme } from '../../../../constants/theme.mjs';
import '../../../Container/index.mjs';
import { WrapPadding } from '../../../Container/Container.styles.mjs';
import '../../../StyleableSvgImage/index.mjs';
import { withCssTransition } from '../DropdownMenu/DropdownMenu.styles.mjs';
import { Container as Container$1 } from '../../../Container/Container.mjs';
import { StyleableSvgImage } from '../../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const MICROSITE_MENU_Z_INDEX = theme.zIndex.header - 1;
const HEADER_NAVIGATION_MICROSITE_MENU_HEIGHT = 130;
const TRANSITION_DURATION_MS = 250;
const Wrap = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: ${MICROSITE_MENU_Z_INDEX};
`;
const MenuWrap = styled.nav`
  background: ${({
  $motif
}) => theme.colors.menu.base[$motif]};
  display: flex;
  height: 264px;
  opacity: 0;
  filter: drop-shadow(0 12px 48px rgb(33 35 39 / 0.12))
    drop-shadow(0 0 1px rgb(33 35 39 / 0.08));
  width: 100%;
  ${withCssTransition(["height", "opacity"])};

  ${({
  $slideInView
}) => $slideInView && css`
      height: 100vh;
      opacity: 1;
    `}
`;
const MenuInnerWrap = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
  overflow: hidden;
  flex-direction: column;
  width: 100%;

  ${({
  $shouldShow
}) => $shouldShow && css`
      opacity: 1;
      padding: 0 16px 16px;
      overflow-y: auto;
    `}
`;
const Container = styled(Container$1)`
  margin: 0;
  padding: 0;
  max-width: 1200px;

  ${WrapPadding} {
    flex-direction: column;
    align-items: flex-start;

    @media ${BREAKPOINTS.SMALL_MOBILE_AND_DOWN} {
      align-items: stretch;
    }
  }
`;
const SubNavItemsWrapper = styled.div`
  gap: 16px;
  display: flex;
  justify-content: center;
`;
const SubNavItem = styled.button`
  align-items: center;
  animation: fade-in-quick 0.5s linear;
  display: flex;
  background: transparent;
  outline: none;
  border: none;
  flex-direction: column;
  flex: 1 1 0px;
  max-width: ${({
  $maxWidth
}) => `${$maxWidth}px`};
  padding: 8px 8px 16px;
  border-radius: 6px;
  transition: all 0.15s linear;

  &:hover {
    box-shadow:
      0 0 1px 0 rgb(33 35 39 / 0.08),
      0 4px 16px 2px rgb(33 35 39 / 0.08);
  }

  ${({
  $isActive
}) => $isActive && css`
      background: #f9f9fa;
    `}

  @keyframes fade-in-quick {
    0% {
      opacity: 0;
    }

    15% {
      opacity: 0.25;
    }

    70%% {
      opacity: 1;
    }

    100% {
      opacity: 1;
    }
  }
`;
const SvgImage = styled(StyleableSvgImage)`
  color: #808893;
  transition: color 0.2s ease-in-out;
`;
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
const StyledImg = styled.img`
  object-fit: contain;
  width: ${({
  $width
}) => $width ?? 120}px;
  height: ${({
  $height
}) => $height ?? 120}px;
  min-width: ${({
  $width
}) => $width ?? 120}px;
  min-height: ${({
  $height
}) => $height ?? 120}px;
`;
const Title = styled.h3`
  align-items: center;
  color: #212327;
  display: flex;
  font-size: 16px;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 8px;
  text-align: center;
`;
const Description = styled.p`
  color: #50565e;
  font-size: 12px;
  height: 100%;
  line-height: 14px;
  margin-bottom: 0;
  margin-top: 4px;
  text-align: center;
  text-wrap: pretty;
`;
const CompareExploreAnchor = styled.a`
  color: #006fff;
  font-size: 12px;
  line-height: 14px;
  margin-top: 8px;
  min-height: 14px;
`;
const Badge = styled.span`
  align-items: center;
  border-radius: 3px;
  border: 1px solid ${theme.colors.primaryBlue};
  color: ${theme.colors.primaryBlue};
  display: flex;
  font-size: 9px;
  font-style: normal;
  height: 16px;
  justify-content: center;
  letter-spacing: -0.018px;
  margin-left: 4px;
  padding: 2px 3px;
  width: fit-content;
`;
const SiteMapWrapper = styled.div`
  background: ${({
  motif
}) => theme.colors.menu.base[motif]};
  display: flex;
  height: 0;
  opacity: 0;
  filter: drop-shadow(0 12px 48px rgb(33 35 39 / 0.12))
    drop-shadow(0 0 1px rgb(33 35 39 / 0.08));
  position: absolute;
  width: 100%;
  ${withCssTransition(["height", "opacity"])};

  ${({
  $slideInView
}) => $slideInView && css`
      height: calc(100vh - 48px);
      opacity: 1;
    `}
`;
const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  min-height: 48px;
  justify-content: space-between;
  align-items: center;
  height: 48px;
`;
const LogoAnchor = styled.button`
  ${withCssTransition(["color"])};
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${theme.colors.black};
  display: flex;
  height: 100%;
  margin-right: 35px;
  padding: 0;
  outline: none;

  :hover {
    color: ${theme.colors.menu.active["light"]};
  }

  @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
    transform: translateX(100%);
    margin-right: 0;
  }
`;
const StyledSvgImage = styled(StyleableSvgImage)`
  color: #808893;
`;
const ButtonLabel = styled.span`
  margin-left: 6px;
`;
export { Badge, ButtonLabel, CompareExploreAnchor, Container, Description, FlexColumn, HEADER_NAVIGATION_MICROSITE_MENU_HEIGHT, HeaderRow, LogoAnchor, MenuInnerWrap, MenuWrap, SiteMapWrapper, StyledImg, StyledSvgImage, SubNavItem, SubNavItemsWrapper, SvgImage, TRANSITION_DURATION_MS, Title, Wrap };
//# sourceMappingURL=SiteMap.styles.mjs.map
